import styled from '../../theme/styled';

interface Props {
  flex?: boolean;
  as?: 'div' | 'section' | 'header';
}

const LucidContainer = styled.div<Props>(({ flex, theme }) => ({
  display: flex ? 'flex' : 'block',
  position: 'relative',
  maxWidth: '90rem',
  margin: '0 auto',
  padding: '0 7.5rem',
  WebkitFontSmoothing: 'antialiased',
  justifyContent: 'space-between',

  [`@media screen and (max-width: ${theme.breakpoints[5]})`]: {
    padding: '0 3.75rem'
  },

  [`@media screen and (max-width: ${theme.breakpoints[2]})`]: {
    padding: '0 1.875rem'
  }
}));

export default LucidContainer;
